<ng-container *ngIf="layout == 0">
  <label class="switch">
    <input id="input-switch" type="checkbox" [(ngModel)]="checked" (change)="toggle()">
    <span class="slider"></span>
  </label>

  <label for="input-switch" class="switch-text">{{label}}</label>
</ng-container>

<div *ngIf="layout == 1" class="app">
  <label for="input-switch" class="layout1-txt">{{label}}</label>
  <label class="checker">
    <input id="input-switch" class="checkbox" type="checkbox" [(ngModel)]="checked" (change)="toggle()" />
    <div class="check-bg"></div>
    <div class="checkmark">
      <svg viewBox="0 0 100 100">
        <path d="M20,55 L40,75 L77,27" fill="none" stroke="#FFF" stroke-width="15" stroke-linecap="round"
          stroke-linejoin="round" />
      </svg>
    </div>
  </label>
</div>

<div *ngIf="layout == 2">
  <div class="flex-toggle-box">
    <label for="input-switch" class="switch-text">{{label}}</label>
    <span>
      <span *ngIf="checked" class="status">{{getString('on')}}</span>
      <span *ngIf="!checked" class="status">{{getString('off')}}</span>
      <label class="switch">
        <input id="input-switch" type="checkbox" [(ngModel)]="checked" [disabled]="!enabled" (change)="toggle()">
        <span class="slider"></span>
      </label>    
    </span>
  </div>
  <p>{{subtitle}}</p>
</div>